export const contactInfo = {
  email: 'hello@loadapi.io',
  company: 'LoadAPI Inc.',
};